import styles from './template.css';
import template from './template';
import {storeInstance} from '@aofl/store/dist/legacy';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';

import translations from '../i18n';

/**
 * @summary ThreeWayToggle
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('three-way-toggle')
class ThreeWayToggle extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of ThreeWayToggle.
   */
  constructor() {
    super();
    this.translations = translations;
    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is = 'three-way-toggle';
  static VALUES = {
    ALL: 'all',
    NONE: 'none',
    SOME: 'some'
  }

  @property({converter(value) {
    if (Object.values(ThreeWayToggle.VALUES).indexOf(value) === -1) {
      throw new TypeError(`Invalid three-way-toggle ${value}`);
    }
    return value;
  }})
  value = ThreeWayToggle.VALUES.NONE;

  toggleValue() {
    if (this.value === ThreeWayToggle.VALUES.NONE) {
      this.value = ThreeWayToggle.VALUES.ALL;
      this.dispatchValue();
    } else if (this.value === ThreeWayToggle.VALUES.ALL) {
      this.value = ThreeWayToggle.VALUES.NONE;
      this.dispatchValue();
    } else if (this.value === ThreeWayToggle.VALUES.SOME) {
      this.value = ThreeWayToggle.VALUES.ALL;
      this.dispatchValue();
    }
  }

  dispatchValue() {
    this.dispatchEvent(new CustomEvent('toggle-change', {
      bubbles: true,
      composed: true
    }));
  }
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export {ThreeWayToggle};
